import type { SpacePlanType } from '@flowus/shared';
import * as Sentry from '@sentry/browser';
import { keys } from 'lodash-es';
import { useCallback } from 'react';
import { request } from 'src/common/request';
import { CREATE_SPACE } from 'src/redux/actions';
import { dispatch } from 'src/redux/store';
import { $spacesState } from 'src/services/spaces/spaces';
import { useFetchMe } from '../user/use-fetch-me';

interface Options {
  title: string;
  planType: SpacePlanType.freePersonal | SpacePlanType.freeTeam;
  industry?: string;
  size?: string;
  scene?: string;
  /** 用户选择的模板 ID 列表 (用于 Buildin 新手引导) */
  templateIds?: string[];
}
/**
 * 创建空间
 */
export const useCreateSpace = () => {
  const fetchMe = useFetchMe();
  return useCallback(
    async (userId: string, options: Options) => {
      const { templateIds, ...createOptions } = options;
      // 目前创建空间依赖于后台接口
      const res = await request.infra.createUserSpace(userId, createOptions);
      try {
        // 初始化空间页面，传递模板 ID 列表
        await request.infra.initSpacePage.raw(res.uuid, 'web', {
          templateIds: templateIds?.length ? templateIds : undefined,
        });
      } catch (err) {
        Sentry.captureException(err);
      }
      dispatch(CREATE_SPACE({ space: res }));
      void fetchMe();
      return res.uuid;
    },
    [fetchMe]
  );
};

export const isNeedCreateSpace = () => {
  return keys($spacesState.getState()).length === 0;
};
